import { Browser } from '@capacitor/browser';

export const openInAppBrowser = async (url: string): Promise<void> => {
  return Browser.open({ url, presentationStyle: 'popover' });
};
